"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CitationCell = exports.CitationCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var format_date_string_1 = require("../../utils/format-date-string");
var truncate_middle_1 = require("../../utils/truncate-middle");
exports.CitationCellDefaultProps = {
  isExtended: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    line-height: 1.6em;\n    color: ", ";\n    word-break: break-word;\n    overflow-wrap: break-word;\n    ", "\n  "], ["\n    line-height: 1.6em;\n    color: ", ";\n    word-break: break-word;\n    overflow-wrap: break-word;\n    ", "\n  "])), theme_1.theme.COLOR('text'), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n    "], ["\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n    "])));
  })
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: block;\n      margin-top: 3px;\n    "], ["\n      display: block;\n      margin-top: 3px;\n    "])));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n    "], ["\n      display: flex;\n      flex-direction: column;\n    "])));
  })
});
var NumberStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    flex-shrink: 0;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    flex-shrink: 0;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  "])), theme_1.theme.FONT_SIZE(10), theme_1.theme.COLOR('text-mid'), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5))
});
var AuthorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UrlLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 500;\n    align-self: flex-start;\n    text-decoration: none;\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-weight: 500;\n    align-self: flex-start;\n    text-decoration: none;\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('dark'))
});
var PublicationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AccessedDateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EditionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var VolumeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ReferencePagesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var YearStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Number: styled_components_1.default.span(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), NumberStyles),
  Body: styled_components_1.default.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled_components_1.default.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Date: styled_components_1.default.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  Author: styled_components_1.default.span(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AuthorStyles),
  Link: styled_components_1.default.a(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Publication: styled_components_1.default.em(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), PublicationStyles),
  AccessedDate: styled_components_1.default.span(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), AccessedDateStyles),
  Edition: styled_components_1.default.span(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), EditionStyles),
  ReferencePages: styled_components_1.default.span(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ReferencePagesStyles),
  Volume: styled_components_1.default.span(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), VolumeStyles),
  Year: styled_components_1.default.span(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), YearStyles),
  UrlLink: styled_components_1.default.a(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), UrlLinkStyles)
};
var CitationCell = function (props) {
  var className = props.className,
    entity = props.entity,
    isExtended = props.isExtended,
    number = props.number,
    showName = props.showName,
    urlMaxLength = props.urlMaxLength;
  var _a = entity.authors,
    authors = _a === void 0 ? [] : _a,
    url = entity.url,
    authorShowsEtAl = entity.authorShowsEtAl,
    footnoteNumber = entity.footnoteNumber,
    publication = entity.publication,
    name = entity.name,
    date = entity.date,
    accessDate = entity.accessDate,
    edition = entity.edition,
    volume = entity.volume,
    year = entity.year,
    startPage = entity.startPage,
    endPage = entity.endPage;
  var hasDate = !!date;
  var hasAuthor = !!authors.length;
  var hasPublication = !!publication;
  var hasAccessedDate = !!accessDate;
  var hasEdition = !!edition;
  var hasVolume = !!volume;
  var hasYear = !!year;
  var hasPage = !!startPage;
  var numberToUse = number || footnoteNumber;
  var hasNumber = numberToUse !== undefined && numberToUse !== null && isExtended;
  var author = "".concat(authors.map(function (author) {
    return author.name;
  }).join(', ')).concat(authorShowsEtAl ? ' et al.' : '');
  var formattedAccessDate = accessDate && (0, format_date_string_1.formatDateString)(accessDate, 'Do MMM YYYY');
  return react_1.default.createElement(My.Container, {
    isExtended: isExtended,
    className: className
  }, hasNumber && react_1.default.createElement(My.Number, null, numberToUse), react_1.default.createElement(My.Body, {
    isExtended: isExtended
  }, react_1.default.createElement(My.Info, {
    isExtended: isExtended
  }, hasAuthor && react_1.default.createElement(My.Author, null, author, ", "), isExtended ? showName && react_1.default.createElement(react_1.default.Fragment, null, "\u2018", name, "\u2019") : react_1.default.createElement(My.Link, {
    target: "_blank",
    href: url
  }, "\u2018", name, "\u2019"), hasDate && react_1.default.createElement(My.Date, null, ", ", date), hasPublication && react_1.default.createElement(My.Publication, null, ", ", publication), hasEdition && react_1.default.createElement(My.Edition, null, ", ", edition), hasVolume && react_1.default.createElement(My.Edition, null, ", Vol. ", volume), hasYear && react_1.default.createElement(My.Year, null, ", ", year), hasPage && react_1.default.createElement(My.ReferencePages, null, ", p.", startPage), hasAccessedDate && react_1.default.createElement(My.AccessedDate, null, ", accessed ", formattedAccessDate), "."), isExtended && react_1.default.createElement(My.UrlLink, {
    target: "_blank",
    href: url
  }, urlMaxLength ? (0, truncate_middle_1.truncateMiddle)(url, urlMaxLength) : url)));
};
exports.CitationCell = CitationCell;
exports.CitationCell.defaultProps = exports.CitationCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;